// Bank Module Initialization
// This file contains all side effects for the bank module.
// It is imported by src/imports.ts at application startup.

import { PAYMENTS, BANK_TRANSACTIONS, OCR_TRANSACTION_VIEW } from '@/bank'
import { registerRoute } from '@/router'
import { useContaCommand } from '@/commandbar/commandBar.service'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'
import { NavGroup, registerNavigationEntry } from '@/navigation'

const { registerNavigationCommand } = useContaCommand()
const { buildSimpleCrumb } = useBreadCrumbs()

// PAYMENTS
registerRoute(PAYMENTS)
const payments_label = 'Betalinger'
const payments_icon = 'i-ph-credit-card-fill'
registerNavigationCommand({
    route: PAYMENTS,
    label: payments_label,
    icon: payments_icon,
    hotkey: 'b'
})
registerNavigationEntry(NavGroup.ACCOUNTING, {
    title: payments_label,
    key: 'payments',
    icon: payments_icon,
    target: PAYMENTS,
    sortOrder: 3
})
buildSimpleCrumb(PAYMENTS, payments_label, payments_icon)

// BANK_TRANSACTIONS
registerRoute(BANK_TRANSACTIONS)
registerNavigationEntry(NavGroup.ACCOUNTING, {
    title: 'Banktransaksjoner',
    key: 'bank-transactions',
    icon: 'i-ph-bank',
    target: BANK_TRANSACTIONS,
    sortOrder: 4
})
buildSimpleCrumb(BANK_TRANSACTIONS, 'Banktransaksjoner', 'i-ph-credit-card-fill')

// OCR_TRANSACTION_VIEW
registerRoute(OCR_TRANSACTION_VIEW)
